"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DescriptionSizes = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var Icon_1 = tslib_1.__importDefault(require("../Icon"));

var styles = tslib_1.__importStar(require("./Description.style"));

exports.DescriptionSizes = ['xlarge', 'large', 'medium', 'small'];

function Description(_ref) {
  var className = _ref.className,
      size = _ref.size,
      iconName = _ref.iconName,
      content = _ref.content;
  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className,
    css: styles.wrapper(size)
  }, {
    children: [jsx_runtime_1.jsx(Icon_1.default, {
      name: iconName,
      alt: "description icon"
    }, void 0), jsx_runtime_1.jsx("span", {
      children: content
    }, void 0)]
  }), void 0);
}

exports.default = Description;